import _ from 'lodash';
import React from 'react';
import { useField } from '~/hooks';
import approvalStatuses from '~/lookups/approval-statuses';
import FieldControl from './FieldControl';
import SingleSelect from './SingleSelect';

const options = _.values(approvalStatuses);

function ExpenseItemStatusSelect(props) {
  return (
    <SingleSelect {...props}>
      {options.map(({ id, name }) => (
        <option key={id} value={id}>
          {name}
        </option>
      ))}
    </SingleSelect>
  );
}

function FieldExpenseItemStatusSelect(props) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  return (
    <FieldControl error={error}>
      <ExpenseItemStatusSelect {...field} {...props} />
    </FieldControl>
  );
}

export default ExpenseItemStatusSelect;
export { FieldExpenseItemStatusSelect };
